export const SHARED_ACTIONS = {
    LOGIN: 'LOGIN',
    CHECK_USERNAME: 'CHECK_USERNAME',
    LOGOUT: 'LOGOUT',
    MESSAGE: 'MESSAGE',
    CLEAN: 'CLEAN',
    CLEAN_MESSAGE: 'CLEAN_MESSAGE',
    CLEAN_LOADING: 'CLEAN_LOADING',
    ACTIVE_LOADING: 'ACTIVE_LOADING',
    DESACTIVE_LOADING: 'DESACTIVE_LOADING',
}